import { AlgoliaSearchParams } from "@omni/types/api/search/algolia/search/algoliaSearchParams.model";
import { SearchResultProductTileConfig } from "@omni/types/components/props/searchResults.props";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { SearchResultsContextProvider } from "@/components/Search/SearchResults/context/searchResults.context";
import { SearchResultsComponent } from "@/components/Search/SearchResults/searchResults.component";
import * as SearchSelectors from "@/redux/modules/value/search/search.selectors";
import { SearchStatus } from "@/redux/modules/value/search/search.types";
import { withBreakpoints } from "@/utils/breakpoints/breakpoints.provider";
import { SearchComponent } from "@/utils/search/types/searchComponent";

import { InitSearch } from "./components/InitSearch/initSearch.container";
import { SaveScrollPosition } from "./components/SaveScrollPosition/saveScrollPosition.container";
import { SearchResultsSkeleton } from "./searchResults.skeleton";

const SEARCH_NO_RESULTS_ID = "searchResults__noResults";

type Props = {
    algoliaSearchParameters?: AlgoliaSearchParams;
    productTileConfig?: SearchResultProductTileConfig;
    showFacets?: boolean;
};

const SearchResultsBase = ({
    algoliaSearchParameters,
    productTileConfig,
    showFacets = true
}: Props) => {
    const status = useSelector(SearchSelectors.getSearchStatus);

    const hasProductResults = useSelector(
        SearchSelectors.hasResults(SearchComponent.PRODUCT_NUMBER_OF_HITS)
    );
    const hasContentResults = useSelector(
        SearchSelectors.hasResults(SearchComponent.CONTENT_NUMBER_OF_HITS)
    );

    const results = useMemo(
        () => hasProductResults || hasContentResults,
        [hasProductResults, hasContentResults]
    );

    useEffect(() => {
        const noResultsComponent =
            document.getElementById(SEARCH_NO_RESULTS_ID);

        if (!results && status !== SearchStatus.Loading) {
            noResultsComponent?.classList.remove(
                // TODO - Style
                "searchResults__noResults--hidden"
            );
        } else {
            noResultsComponent?.classList.add(
                // TODO - Style
                "searchResults__noResults--hidden"
            );
        }
    }, [status, results]);

    return (
        <SearchResultsContextProvider
            algoliaSearchParameters={algoliaSearchParameters}
            productTileConfig={productTileConfig}
            showFacets={showFacets}
        >
            {status === SearchStatus.Loading && !results && (
                <SearchResultsSkeleton />
            )}
            {(status !== SearchStatus.Loading || results) && (
                <SearchResultsComponent />
            )}
            <SaveScrollPosition />
            <InitSearch />
        </SearchResultsContextProvider>
    );
};

export const SearchResults = withBreakpoints(SearchResultsBase);
